// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import BundleAllocationCapacityForecast from '../shared/bundle-allocation-to-capacity-forecast';
import React from 'react';

function BundleAllocationToCapacityPage () {

    return (
        <AuthenticatedPage className="atp-page atp-bundle-allocation-to-capacity-page">
            <BundleAllocationCapacityForecast bundleCapacity={true} />
        </AuthenticatedPage>
    );

}
BundleAllocationToCapacityPage.displayNAme = 'BundleAllocationToCapacityPage';

export default BundleAllocationToCapacityPage;
